export default __webpack_public_path__ + "assets/media/correct-answer.7a33b61f.mp3";